/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Wishesproofofpayment3Inputs */

const de__field_wishesproofofpayment3 = /** @type {(inputs: _Field_Wishesproofofpayment3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachweis über Beitragszahlungen gewünscht`)
};

/**

* @param {_Field_Wishesproofofpayment3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_wishesproofofpayment3 = /** @type {((inputs?: _Field_Wishesproofofpayment3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Wishesproofofpayment3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_wishesproofofpayment3(inputs)
});
export { _field_wishesproofofpayment3 as "_field_wishesProofOfPayment" }